import { render } from "./CometChatBadgeCount.vue?vue&type=template&id=ba5aedb2"
import script from "./CometChatBadgeCount.vue?vue&type=script&lang=js"
export * from "./CometChatBadgeCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__